import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import configureStore from 'store';
import reset from 'styles/reset';
import Route from 'route';
import { langAll } from 'locales';
import registerServiceWorker from 'registerServiceWorker';

const GlobalStyle = createGlobalStyle`
  ${reset}
`
const store = configureStore();
const pathname = location.pathname;
const curLang = langAll.filter(item => pathname.indexOf(item) > 0 && item);
const navLang = langAll.filter(item => navigator.language === item && item);
curLang[0] = curLang[0] || navLang[0] || 'ko-KR';
localStorage.setItem('lang', curLang[0]);

const rootElement = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle/>
    <Route />
  </Provider>,
  rootElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx